"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Translator = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _index = require("../api/index");
var Translator = /*#__PURE__*/function () {
  function Translator(transFolder) {
    (0, _classCallCheck2["default"])(this, Translator);
    this.translations = {};
    this.mustSaveTrans = false;
    this.folder = '';
    this.lang = 'en_GB';
    this.folder = transFolder;
  }
  (0, _createClass2["default"])(Translator, [{
    key: "setTranslations",
    value: function setTranslations(translations) {
      if (translations) this.translations = translations;
    }
  }, {
    key: "loadTranslations",
    value: function () {
      var _loadTranslations = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(lang) {
        var _this = this;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (lang === 'DE') lang = 'D';
              return _context.abrupt("return", new _promise["default"](function (resolve, reject) {
                _index.QueryAPI.getGuestTranslation(lang, _this.folder, function (json) {
                  if (json) {
                    _this.setTranslations(json);
                    _this.mustSaveTrans = false;
                  }
                  resolve(json);
                }, reject);
              }));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function loadTranslations(_x) {
        return _loadTranslations.apply(this, arguments);
      }
      return loadTranslations;
    }()
  }, {
    key: "saveTranslations",
    value: function () {
      var _saveTranslations = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var _this2 = this;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new _promise["default"](function (resolve, reject) {
                _index.QueryAPI.saveTranslations(_this2.folder, _this2.translations, function (json) {
                  _this2.mustSaveTrans = false;
                  resolve(json);
                }, reject);
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function saveTranslations() {
        return _saveTranslations.apply(this, arguments);
      }
      return saveTranslations;
    }()
  }, {
    key: "setLang",
    value: function () {
      var _setLang = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(langCode) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.lang = langCode;
              return _context3.abrupt("return", this.loadTranslations(this.lang));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function setLang(_x2) {
        return _setLang.apply(this, arguments);
      }
      return setLang;
    }()
  }, {
    key: "getLang",
    value: function getLang() {
      return this.lang;
    }
  }, {
    key: "translate",
    value: function translate() {
      var translation = arguments.length <= 0 ? undefined : arguments[0];
      if (typeof translation === "string") {
        var _context4;
        var key = (0, _trim["default"])(_context4 = translation.toLowerCase()).call(_context4);
        if (this.translations[key]) translation = this.translations[key];else {
          this.translations[key] = '';
          this.mustSaveTrans = true;
        }
      }
      for (var i = 1; i < arguments.length; i++) {
        var reg = new RegExp("\\{".concat(i - 1, "\\}"), 'g');
        translation = translation.replace(reg, i < 0 || arguments.length <= i ? undefined : arguments[i]);
      }
      return translation;
    }
  }]);
  return Translator;
}();
exports.Translator = Translator;
//# sourceMappingURL=Translator.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/controllers/Translator.js
// module id = 1259
// module chunks = 142